module.exports = __webpack_public_path__ + "static/media/useitup.bf8af77b.jpg";